import { useQuery } from "react-query";
import axios from "axios";
import { IKidsCombo } from "../models/item.model";
import { LOCATION_MENU_SERVICE } from "../constants";
import axiosWithInterceptor from "../services/axiosWithInterceptor";

interface IQueryParams {
  location_id: string;
  category_id: string;
  item_id: string;
}

const getKidsCombo = async ({
  location_id,
  category_id,
  item_id,
}: IQueryParams) => {
  //TODO: Backend need any random item id, Remove it in future when backend will doesn't
  const response = await axiosWithInterceptor.get(
    `${LOCATION_MENU_SERVICE}/getLocationMenuItem?item_id=${item_id}&location_id=${location_id}&category_id=${category_id}`
  );
  return response?.data?.data?.categories[0];
};

export default function useKidsCombo(queryParams: IQueryParams) {
  return useQuery<IKidsCombo>(["kidscombo", queryParams.category_id], () =>
    getKidsCombo(queryParams), {
      enabled: !!(queryParams?.category_id && queryParams?.item_id && queryParams?.location_id ),
    }
  );
}
